<template>
  <VCol cols="auto" class="legal-links-col">
    <!-- One flex-wrap container, links as direct siblings and no pipe separators (FR-007).
         Gaps and wrapping come from FooterLegal's scoped style. Kept inside the
         root: beside it, the comment made the root a fragment in dev, which cannot
         inherit FooterLegal's data-testid. -->
    <div class="footer-legal-links">
      <FooterButton legal-link to="/legal/terms-of-use" data-testid="terms">
        {{ $t('footer.link.terms') }}
      </FooterButton>
      <FooterButton legal-link to="/legal/privacy-policy" data-testid="privacy-policy">
        {{ $t('footer.link.privacy') }}
      </FooterButton>
      <FooterButton
        v-if="localeStore.countryIsUs"
        legal-link
        to="/legal/ca-supply-chain"
        data-testid="ca-supply-chain"
      >
        {{ $t('footer.link.supply') }}
      </FooterButton>
      <FooterButton
        legal-link
        :on-activate="showOsano"
        :aria-label="$t('footer.link.cookie')"
      >
        {{ $t('footer.link.cookie') }}
      </FooterButton>
    </div>
  </VCol>
</template>

<script lang="ts" setup>
import FooterButton from '~/components/layout/footer/FooterButton.vue'
import { useLocaleStore } from '~/stores/locale'

// FooterLegal tags this block with its component name (data-testid).
defineOptions({ name: 'FooterLegalNa' })

const localeStore = useLocaleStore()

const { showOsano } = useOsano()
</script>
